import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    borderRadius: 16,
    overflow: 'hidden',
    background: '#fff',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.10)',
    border: '1px solid rgba(179, 0, 0, 0.25)',
    transition: 'transform .25s ease, box-shadow .25s ease',
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.03)',
      boxShadow: '0px 6px 18px rgba(0,0,0,0.22)',
      border: '1px solid rgba(179, 0, 0, 0.35)',
    },
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: '0 auto',
    maxWidth: 320,
    [theme.breakpoints.up('sm')]: { maxWidth: 360 },
    [theme.breakpoints.up('md')]: { maxWidth: 260 },
    [theme.breakpoints.up('lg')]: { maxWidth: 300 },
    [theme.breakpoints.up('xl')]: { maxWidth: 340 },
  },
  card: {
    borderRadius: 0,
    boxShadow: 'none',
  },
  header: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '6px 0 2px 0',
    color: '#000',
  },
  imageBox: {
    height: 105,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 20,
  },
  image: {
    height: '100%',
    width: 'auto',
    objectFit: 'contain',
  },
  bottomLine: {
    height: 10,
    backgroundColor: '#b30000',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
  },
}));

export default function SisefTipoSolicitudes({ data, image, onClick }) {
  const classes = useStyles();
  const { nombre } = data;
  return (
    <div className={classes.wrapper} onClick={onClick}>
      <Card className={classes.card} elevation={0}>
        <CardHeader
          title={nombre}
          titleTypographyProps={{ className: classes.header }}
        />
        <Grid container>
          <Grid item xs={12} className={classes.imageBox}>
            <img src={image} alt="" className={classes.image} />
          </Grid>
        </Grid>
      </Card>
      <div className={classes.bottomLine} />
    </div>
  );
}